export default Object.freeze({
  CREATE: 'add',
  READ: 'read',
  EDIT: 'write',
  DELETE: 'delete',
  PLAYBACK_RECORD_FILE: 'playbackRecordFile',
});
